class Multiselect {
  constructor(element) {
    this.container = element
    this.select = this.container.querySelector('select')
    this.input = this.container.querySelector('input[type="text"]')

    this.handleSelect = this.handleSelect.bind(this)

    this.init()
  }

  handleSelect() {
    const { value } = this.select
    if (this.input) {
      this.handleInput(value.toLowerCase() === 'other')
    }
  }

  handleInput(show = false) {
    const inputContainer = this.input.closest('.form__group')

    if (inputContainer) {
      inputContainer.style.display = show ? 'block' : 'none'
    } else {
      this.input.style.display = show ? 'block' : 'none'
    }

    this.input.required = show
  }

  init() {
    if (this.select) {
      this.select.addEventListener('input', this.handleSelect)
      this.handleSelect()
    }
  }
}

const multiselectInit = {
  init() {
    const elements = document.querySelectorAll('.multiselect-field')
    Array.from(elements).map(element => new Multiselect(element))
  },
}

export default multiselectInit
